import Main from '../../views/main'
import {ParentView} from '../../ladmin/components/LParentView'

export default [
  /* -------------- 违章处理 -------------- */
  {
    path: '/violation',
    name: 'Violation',
    component: Main,
    meta: {
      // hideInBread: true,
      disabled: true,
      label: '违章处理'
    },
    children: [
      {
        name: 'ViolationEventManagement',
        path: 'event',
        component: () => import(/* webpackChunkName: "violation" */ '@/views/Violation/Event/management'),
        meta: {
          label: '违章事件',
        },
      },
      {
        name: 'ViolationEventParent',
        path: 'event',
        redirect: {name: 'ViolationEventManagement'},
        component: ParentView,
        meta: {
          label: '违章事件处理',
        },
        children: [
          {
            name: 'ViolationEventDetails',
            path: ':plate/readonly',
            component: () => import(/* webpackChunkName: "violation" */ '@/views/Violation/Event/details'),
            props: true,
            meta: {
              label: '事件详情',
              subText: 'params.plate',
              cacheKey: 'query.id'
            },
          },
          {
            name: 'ViolationEventSubmit',
            path: 'new',
            component: () => import(/* webpackChunkName: "violation" */ '@/views/Violation/Event/submit'),
            // component: newUser,
            props: true,
            meta: {
              label: '上报事件',
              beforeCloseName: 'defaultBeforeClose'
            },
          },
          {
            name: 'ViolationEventHandle',
            path: ':plate/handle',
            component: () => import(/* webpackChunkName: "violation" */ '@/views/Violation/Event/handle'),
            props: true,
            meta: {
              label: '处理事件',
              subText: 'params.plate',
              cacheKey: 'query.id',
            },
          },
          {
            name: 'ViolationEventConfirm',
            path: ':plate/confirm',
            component: () => import(/* webpackChunkName: "violation" */ '@/views/Violation/Event/confirm'),
            props: true,
            meta: {
              label: '确认事件',
              subText: 'params.plate',
              cacheKey: 'query.id',
            },
          }
        ]
      },
      {
        // 不能加props，有属性重名
        name: 'ViolationRuleManagement',
        path: 'rule',
        component: () => import(/* webpackChunkName: "violation" */ '@/views/Violation/Rule/management'),
        meta: {
          label: '违章规则',
        },
      },
      {
        name: 'ViolationRuleParent',
        path: 'rule',
        redirect: {name: 'ViolationRuleManagement'},
        component: ParentView,
        meta: {
          label: '违章规则管理',
        },
        children: [
          {
            name: 'ViolationRuleDetails',
            path: ':name/readonly',
            component: () => import(/* webpackChunkName: "violation" */ '@/views/Violation/Rule/details'),
            props: true,
            meta: {
              label: '规则详情',
              subText: 'params.name',
              cacheKey: 'query.id'
            },
          },
          {
            name: 'NewViolationRule',
            path: 'new',
            component: () => import(/* webpackChunkName: "violation" */ '@/views/Violation/Rule/newRule'),
            // component: newUser,
            props: true,
            meta: {
              label: '新增违章规则',
              beforeCloseName: 'defaultBeforeClose'
            },
          },
          {
            name: 'EditViolationRule',
            path: ':name/edit',
            component: () => import(/* webpackChunkName: "violation" */ '@/views/Violation/Rule/editRule'),
            props: true,
            meta: {
              label: '编辑规则',
              subText: 'params.name',
              cacheKey: 'query.id',
            },
          }
        ]
      },
      {
        name: 'ViolationHistory',
        path: 'history',
        component: () => import(/* webpackChunkName: "violation" */ '@/views/Violation/History/list'),
        meta: {
          label: '日志查询',
        },
      },
      {
        name: 'AppointmentOrgViolationStatistics',
        path: 'history/appointment-org-statistics',
        component: () => import(/* webpackChunkName: "violation" */ '@/views/Violation/History/appointmentOrgStatistics'),
        meta: {
          label: '单位预约违章统计'
        }
      },
      {
        name: 'ViolationArea',
        path: 'area',
        component: () => import(/* webpackChunkName: "violation" */ '@/views/Violation/Area/list'),
        meta: {
          label: '区域设置',
        },
      }
    ]
  },
]
